export default {"src":"/_next/static/media/logout.a5bbfadf.svg","height":12,"width":14};